export const MULTICARD_TIMING_PRECISION = 1000; // milliseconds
export const MULTICARD_MIN_DISPLAY_TIME = 500; // minimum time to display a subcard
export const MULTICARD_DEFAULT_DIFFICULTY = 'good' as const;
export const MULTICARD_PROGRESS_SEPARATOR = ' of ';
export const MULTICARD_BUTTON_TEXT = {
    ONE_MORE: 'One more',
    SHOW_ANSWER: 'Show Answer',
    GOT_IT_WRONG: 'Got It Wrong',
    GOT_IT_RIGHT: 'Got It Right',
    FINISH_CARD: 'Finish & rate card',
} as const;